// Reusable currency formatter
// Formats numbers with comma as thousands separator and two decimal places.
// Accepts numbers or numeric strings. Returns string like "$1,234.56".
export default function formatCurrency(value) {
  const num = Number(value || 0);
  if (!isFinite(num)) return '$0.00';

  const sign = num < 0 ? '-' : '';
  const abs = Math.abs(num);

  // Use Intl.NumberFormat for reliable formatting
  const formatter = new Intl.NumberFormat(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return `${sign}$${formatter.format(abs)}`;
}
